
import {helpers} from '@/ft-vue-core'

const {escapeRegExp, parseRegExp} = helpers

export default {
  data: function () {
    return {
      orphanedDetailAnswers: new WeakMap(),
      orphanedAnswers: [],
      questions: [],
      questionLookupById: {},
      answersLookupByQuestion: new WeakMap(),
      answersLookupByAnswer: new WeakMap(),
      detailLookupByAnswer: new WeakMap()
    }
  },
  computed: {
    detailQuestions () {
      return this.questions.filter(q => q.askEachReservee)
    },
    reservationQuestions () {
      return this.questions.filter(q => !q.askEachReservee)
    }
  },
  methods: {
    activeValues (a) {
      const q = a.q
      if (!q.isDependent) return q.values.filter(v => !v.disabled)
      const dqId = q.dependentQuestionId
      const dq = this.questionLookupById[dqId]
      const sameLevel = q.askEachReservee === dq.askEachReservee
      if (sameLevel || q.askEachReservee) {
        // Reservee answer depends on different answer from same reservee, or a reservation answer
        // Or reservation answer depends on reservation answer
        const da = (sameLevel ? this.answersLookupByAnswer.get(a) : this.itemData.answers).find(sa => sa.questionId === dqId)
        return a.q.values.filter(v => !v.disabled && da.value !== null && da.value.length && da.value.match(v.dependentRegexp))
      } else {
        // Reservation answer depends on reservee answer
        const das = this.answersLookupByQuestion.get(dq)
        if (!das) return [] // No answers mapped to this?
        // Search relevant answers in all reservees
        return a.q.values.filter(v => !v.disabled && das.find(da => da.value !== null && da.value.length && da.value.match(v.dependentRegexp) && this.isActiveAnswer(da)))
      }
    },
    isActiveAnswer (a, depth = 0) {
      const q = a.q
      if (!q) return false
      const detail = this.detailLookupByAnswer.get(a)
      // if (detail && this.guestTbdId !== null && detail.guestTypeId === this.guestTbdId) return false // No answers for TBD
      if (q.guestsOnly) {
        if (detail && detail.guestTypeId === null) {
          return false // Reservee guest only question, and reservee is not a guest
        } else if (!q.askEachReservee && !this.hasGuests) {
          return false
        }
      }
      if (!q.isDependent) return true
      depth += 1
      if (depth > this.questions.length) {
        // If we're over the size of our questions, then we must be stuck in a recursive loop.
        console.warn('Question dependence recursion detected.')
        return false
      }
      const dqId = q.dependentQuestionId
      const dq = this.questionLookupById[dqId]
      // console.warn('askEachReservee', q, dq)
      if (!dq) return false
      const sameLevel = q.askEachReservee === dq.askEachReservee
      if (sameLevel || q.askEachReservee) {
        // Reservee answer depends on different answer from same reservee, or a reservation answer
        // Or reservation answer depends on reservation answer
        const da = (sameLevel ? this.answersLookupByAnswer.get(a) : this.itemData.answers).find(sa => sa.questionId === dqId)
        return da.value !== null && da.value !== undefined && da.value.length && da.value.match(q.dependentRegexp) && this.isActiveAnswer(da, depth)
      } else {
        // Reservation answer depends on reservee answer
        const das = this.answersLookupByQuestion.get(dq)
        if (!das) return false // No answers mapped to this?
        // Search relevant answers in all reservees
        return !!das.find(da => da.value !== null && da.value.length && da.value.match(q.dependentRegexp) && this.isActiveAnswer(da, depth))
      }
    },
    questionsCommands () {
      const seatingTime = this.selectedSeatingTime
      if (this.forEvent && !this.itemData.eventId || !this.forEvent && !seatingTime) return null
      const command = {
        command: 'diningQuestion',
        load: this.questions,
        loading: this.isLoading
      }
      this.addCommandParam(command, 'children', true)
      this.addCommandParamArrayVal(command, 'filter', {field: 'disabled', operator: 'EQUAL', values: [false]})
      if (this.forEvent) {
        this.addCommandParamArrayVal(command, 'filter', {field: 'eventId', operator: 'EQUAL', values: [this.itemData.eventId]})
      } else {
        this.addCommandParamArrayVal(command, 'filter', {field: 'mealPeriodId', operator: 'EQUAL', values: [seatingTime.mealPeriodId]})
      }
      return [command]
    },
    loadQuestions () {
      const commands = this.questionsCommands()
      if (!commands) {
        // Not enough filled out to know what questions to ask
        this.questions = []
        return
      }
      // Load questions
      this.$ftAPI().get(this.addResourceErrorHandler(commands))
    },
    generateDetailWarnings () {
      const l = this.itemDetails.length
      const warnings = new Array(l)
      for (let i = 0; i < l; i += 1) {
        const warning = []
        if (i + 1 > this.maxPartySize) {
          warning.push(this.overPartySizeMessage)
        }
        warnings[i] = warning.length ? warning : false
      }
      this.detailWarnings = warnings
    },
    generateAnswersFor (questions, answers, id, idKey, detail) {
      var answer
      const results = []
      const foundAnswers = new WeakSet()
      var orphanedAnswers = detail ? this.orphanedDetailAnswers.get(detail) || [] : this.orphanedAnswers
      const allAnswers = answers.concat(orphanedAnswers)
      // Match questions with answers
      for (let question of questions) {
        answer = allAnswers.find(a => a.questionId === question.id || a.question === question.question)
        if (!answer) {
          // Add default answer
          answer = {questionId: question.id, question: question.question, pos: 0, value: null, q: question}
          answer[idKey] = id
          answers.push(answer)
        } else {
          answer.questionId = question.id
          answer.question = question.question
          answer.q = question
        }
        // Store result
        results.push(answer)
        foundAnswers.add(answer)
        // Store lookups
        const answersByQuestion = this.answersLookupByQuestion.get(question) || []
        answersByQuestion.push(answer)
        this.answersLookupByQuestion.set(question, answersByQuestion)
        this.answersLookupByAnswer.set(answer, results)
        if (detail) {
          this.detailLookupByAnswer.set(answer, detail)
        }
      }
      // Keep answers that don't seem to have any related question
      // This can happen on form load, when switching times, etc.
      orphanedAnswers = allAnswers.filter(a => !foundAnswers.has(a))
      // console.log('Generated answers', results, allAnswers, orphanedAnswers, detail)
      if (detail) {
        this.orphanedDetailAnswers.set(detail, orphanedAnswers)
      } else {
        this.orphanedAnswers = orphanedAnswers
      }
      // Return results
      return results
    },
    buildDependentAnswerRegExp (dependentAnswer) {
      dependentAnswer = dependentAnswer ? dependentAnswer.trim() : ''
      if (!dependentAnswer) {
        // Match any non-empty answer
        return /./
      } else {
        const regexp = parseRegExp(dependentAnswer)
        if (regexp) {
          // A regexp has been supplied
          try {
            return new RegExp(regexp[1], regexp[2])
          } catch (e) {
            // Provided regexp is invalid.  Use a regexp that will never match anything
            console.warn('Invalid dependentAnswer RegExp: ', dependentAnswer)
            return /(?!x)x/
          }
        } else {
          // List of answers?
          // Build a regexp that matches any of them
          const regexpList = dependentAnswer.split('|').map(a => escapeRegExp(a.trim()))
          return new RegExp('^(' + regexpList.join('|') + ')$', 'i')
        }
      }
    },
    generateAnswers () {
      // Generate new empty answers or link existing answers to questions for a specified Meal period or event
      // TODO: Do the reverse of generating questions for answers in past reservations that no longer have an applicable meal period.
      const isDirty = this.isDirty
      this.answersLookupByQuestion = new WeakMap()
      this.questions.forEach(q => {
        // Add to lookup
        this.questionLookupById[q.id] = q
        if (q.isDependent) {
          // generate regexp for dependent answer
          if (!q.dependentRegexp) {
            q.dependentRegexp = this.buildDependentAnswerRegExp(q.dependentAnswer)
            q.values.forEach(v => {
              // generate regexp for dependent value options
              v.dependentRegexp = this.buildDependentAnswerRegExp(v.dependentAnswer)
            })
          }
        }
      })
      this.itemData.answers = this.generateAnswersFor(this.reservationQuestions, this.itemData.answers, this.itemData.id, 'reservationId')
      for (let detail of this.itemData.details) {
        detail.answers = this.generateAnswersFor(this.detailQuestions, detail.answers, detail.id, 'reservationDetailId', detail)
      }
      // Reset isDirty flag
      setTimeout(() => {this.isDirty = isDirty}, 0)
      this.resetItemFieldErrorLookup()
    }
  },
  watch: {
    questions () {
      this.generateAnswers()
    }
  }
}
